<app-aps-create-business-client-side-form
	[clientName]="client?.name"
	[fax]="client?.fax"
	[phoneNumber]="client?.phone"
	[email]="client?.email"
	[primary]="primaryContact"
	[type]="client?.type"
	(onCreate)="_onCreate($event)"
	[enableSigningOfficers]="enableSigningOfficers"
	[showPrimaryClientOption]="showPrimaryClientOption"
	(onCancel)="_onCancel()"
>
</app-aps-create-business-client-side-form>
